import axios from 'axios'

const API_PATH = `${process.env.REACT_APP_ENV === 'local' ? '' : '/tsp'}/manage/car`;
const API_PATH_V2 = `${process.env.REACT_APP_ENV === 'local' ? '' : '/v2'}/manage/car`;

// 車輛管理 -> VIG 連線狀態
const getCarVigStatus = async (resource) =>
  await axios.get(`${API_PATH}/vig/status`, { params: resource })

const wakeUpCarVig = async (resource) =>
  await axios.post(`${API_PATH}/vig/wakeUp`, resource)

// 車輛管理 -> IMEI 查詢
const getCarImei = async (resource) =>
  await axios.get(`${API_PATH}/imei`, { params: resource })

// 車輛管理 -> TBox 管理
const getCarTbox = async (resource) =>
  await axios.get(`${API_PATH_V2}/tbox`, { params: resource })

const createCarTbox = async (resource) =>
  await axios.post(`${API_PATH_V2}/tbox`, resource)

const updateCarTbox = async (resource) =>
  await axios.put(`${API_PATH_V2}/tbox`, resource)

const importCarTbox = async resource => (
  await axios.post(`${API_PATH_V2}/tbox/import`, resource, { headers: { "Content-Type": "multipart/form-data" } })
)

// 車輛管理 -> TBox 連線狀態
const getCarTboxStatus = async (resource) =>
  await axios.get(`${API_PATH}/tbox/connectStatus`, { params: resource })

const wakeUpCarTbox = async (resource) =>
  await axios.post(`${API_PATH}/tbox/wakeUp`, resource);

const getCarConnectHistory = async (resource) =>
  await axios.get(`${API_PATH_V2}/tboxconnect/history`, { params: resource })

// 車輛管理 -> 車輛維修狀態
const getRepairProgress = async (resource) =>
  await axios.get(`${API_PATH}/repair/getRepairProgress`, { params: resource })

const addRepairProgress = async (resource) =>
  await axios.post(`${API_PATH}/repair/addRepairProgress`, resource)

const updateRepairProgress = async (resource) =>
  await axios.post(`${API_PATH}/repair/updateRepairProgress`, resource)

// 車輛管理 -> 車輛GPS管理
const getCarGpsStatus = async (resource) =>
    await axios.get(`${API_PATH}/gps/getStatus`, { params: resource })

const updateGpsStatus = async (resource) =>
    await axios.post(`${API_PATH}/gps/updateGpsStatus`, resource)

// 車輛管理 -> 車輛查詢

const getManageCar = async (resource) =>
  await axios.get(`${API_PATH_V2}`, { params: resource })

const getCarInformation = async (resource) =>
  await axios.get(`${API_PATH_V2}/information`, { params: resource })

const getCarMember = async (resource) =>
  await axios.get(`${API_PATH_V2}/member`, { params: resource })

const putCarNo = async (carNo , resource) =>
  await axios.put(`${API_PATH_V2}/${carNo}/consultant` , resource)

const postCarVehicleWakeup = async (resource) =>
  await axios.post(`${API_PATH_V2}/wakeup`, resource)

const putCarVehicleServiceStatus = async (carNo, resource) =>
  await axios.put(`${API_PATH_V2}/${carNo}/service/status`, resource)

const putCarVehicleGpsStatus = async (carNo, resource) =>
  await axios.put(`${API_PATH_V2}/${carNo}/gps?gpsStatus=${resource.gpsStatus}`, resource)

const getCarVehicleLatest30SecondData = async (vinNumber) =>
    await axios.get(`${API_PATH_V2}/${vinNumber}/latest30secend`)

const getCarBindHistory = async (resource) =>
    await axios.get(`${API_PATH_V2}/${resource.carNo}/member/history`)

const deleteCarVehicleRelation = async (ikeyUid, carNo) =>
  await axios.delete(`${API_PATH_V2}/${carNo}/member/${ikeyUid}`)

const deleteCarVehicleKeyRelation = async (resource) =>
  await axios.delete(`${API_PATH_V2}/key`, { data: resource })

export { getCarVigStatus, wakeUpCarVig, getCarImei, getCarTbox, createCarTbox, updateCarTbox,
    importCarTbox, getCarTboxStatus, wakeUpCarTbox, getCarConnectHistory, 
    getRepairProgress, addRepairProgress, updateRepairProgress,
    getCarGpsStatus , updateGpsStatus , getManageCar , getCarInformation , getCarMember , putCarNo,
    postCarVehicleWakeup, putCarVehicleServiceStatus, putCarVehicleGpsStatus, getCarVehicleLatest30SecondData, 
    getCarBindHistory, deleteCarVehicleRelation, deleteCarVehicleKeyRelation }
